import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useFunnel } from '../../contexts/FunnelContext'
import { ProgressBar } from '../../components/funnel/ProgressBar'
import { SelectionCard } from '../../components/funnel/SelectionCard'
import { Home, Building2 } from 'lucide-react'

const Step1Page: React.FC = () => {
  const navigate = useNavigate()
  const { state, setHomeType } = useFunnel()

  const handleSingleFamilyClick = () => {
    setHomeType('single-family')
    navigate('/winter-refresh/step-2')
  }

  const handleOtherClick = () => {
    setHomeType('condo-other')
  }

  return (
    <div style={{ backgroundColor: 'rgb(246, 246, 241)', minHeight: '100vh', padding: '2rem 0' }}>
      <div className="mx-auto max-w-2xl px-8">
        <ProgressBar currentStep={1} totalSteps={4} />

        <h1
          className="text-4xl font-bold mb-4"
          style={{ color: '#145F6B', fontFamily: 'Begum' }}
        >
          Get Your Home Winter-Ready & Receive a $100 Gift Card
        </h1>

        <p className="text-lg mb-8" style={{ color: 'rgb(76,76,75)' }}>
          Our limited-time Winter Home Refresh service ensures your home is safe and prepared for
          the season. Start by telling us about your home.
        </p>

        <h3 className="text-2xl font-semibold mb-6" style={{ color: 'rgb(15,15,15)' }}>
          What type of home do you own?
        </h3>

        <div className="space-y-4 mb-8">
          <SelectionCard onClick={handleSingleFamilyClick}>
            <Home className="w-8 h-8" style={{ color: '#145F6B' }} />
            <span className="text-lg" style={{ color: 'rgb(15,15,15)' }}>
              Single-Family Home
            </span>
          </SelectionCard>

          <SelectionCard onClick={handleOtherClick}>
            <Building2 className="w-8 h-8" style={{ color: '#145F6B' }} />
            <span className="text-lg" style={{ color: 'rgb(15,15,15)' }}>
              Condo / Townhome / Other
            </span>
          </SelectionCard>
        </div>

        {state.homeType === 'condo-other' && (
          <div
            className="p-4 rounded-lg border-2"
            style={{ borderColor: '#9B775D', backgroundColor: 'rgb(246, 241, 237)' }}
          >
            <p className="text-base" style={{ color: 'rgb(15,15,15)' }}>
              Thank you for your interest! This offer is currently exclusive to single-family
              homes. Please visit our main site to learn about our other services.
            </p>
          </div>
        )}
      </div>
    </div>
  )
}

export default Step1Page

